import { RecordCalendarControlsView } from "@product/app/workspace/channels/[channelId]/record-calendar-controls-view";
import { calendarZonedDate } from "@product/app/workspace/channels/[channelId]/record-calendar-timezone";
import {
  calendarMonth,
  RecordCalendarLensView,
  RecordCalendarLockedNoteView,
  RecordCalendarMonthView,
} from "@product/app/workspace/channels/[channelId]/record-calendar-view";

import type { ShotCalendar } from "./channel-calendar";

/**
 * A saved calendar view at rest, as RecordCalendarLens draws it on a month:
 * the controls row, the note saying why the dates cannot be dragged, then
 * the month grid with the records on their days. The dates are read in the
 * calendar's timezone here, where the month is drawn, so every viewer sees
 * the same days.
 */
export function ShotCalendarView({ calendar }: { calendar: ShotCalendar }) {
  const zoned = (wallClock: string) => calendarZonedDate(wallClock, calendar.timezone);
  const month = calendarMonth(
    zoned(calendar.anchor),
    calendar.weekStartsOn,
    calendar.events.map((event) => ({ ...event, start: zoned(event.start), end: zoned(event.end) })),
  );
  return (
    <RecordCalendarLensView>
      <RecordCalendarControlsView
        heading={calendar.heading}
        timezone={calendar.timezone}
        mode="month"
        atToday={calendar.atToday}
      />
      {calendar.lockedReason ? <RecordCalendarLockedNoteView reason={calendar.lockedReason} /> : null}
      <RecordCalendarMonthView month={month} today={zoned(calendar.today)} />
    </RecordCalendarLensView>
  );
}
